import type { CareerExplorerSelectorOption } from '@highereducation/hen-ui';

export function labelFor(
  options: CareerExplorerSelectorOption[],
  id: string | null,
): string | null {
  if (!id) return null;
  return options.find((option) => option.id === id)?.label ?? null;
}

export function withFallback(
  options: CareerExplorerSelectorOption[] | undefined,
  fallback: CareerExplorerSelectorOption[],
): CareerExplorerSelectorOption[] {
  return options?.length ? options : fallback;
}
